import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Background", path: "/background" },
  { label: "Businesses", path: "/impact-businesses" },
  { label: "Workers", path: "/impact-workers" },
  { label: "Consumers", path: "/impact-consumers" },
  { label: "Citations", path: "/citations" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <nav
      data-testid="navbar"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        backgroundColor: "rgba(5,5,5,0.88)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
        borderBottom: "1px solid rgba(255,255,255,0.07)",
      }}
    >
      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          padding: "0 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "64px",
        }}
      >
        {/* Brand */}
        <Link
          to="/"
          data-testid="nav-brand"
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "11px",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: "#A1A1AA",
            textDecoration: "none",
          }}
        >
          Macro / Research
        </Link>

        {/* Desktop Links */}
        <div
          className="desktop-nav"
          style={{ display: "flex", alignItems: "center", gap: "32px" }}
        >
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              style={{
                fontSize: "13px",
                fontWeight: 500,
                color: location.pathname === link.path ? "#FFFFFF" : "#A1A1AA",
                textDecoration: "none",
                transition: "color 0.15s ease",
                borderBottom:
                  location.pathname === link.path
                    ? "1px solid #FF3B30"
                    : "1px solid transparent",
                paddingBottom: "2px",
              }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Button */}
        <button
          data-testid="mobile-menu-btn"
          onClick={() => setMobileOpen(!mobileOpen)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#A1A1AA",
            padding: "4px",
            display: "none",
          }}
          className="mobile-menu-btn"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-nav-menu"
          style={{
            backgroundColor: "#0A0A0A",
            padding: "8px 24px 20px",
            borderTop: "1px solid #27272A",
          }}
        >
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`mobile-nav-${link.label.toLowerCase()}`}
              onClick={() => setMobileOpen(false)}
              style={{
                display: "block",
                padding: "12px 0",
                fontSize: "14px",
                fontWeight: 500,
                color:
                  location.pathname === link.path ? "#FFFFFF" : "#A1A1AA",
                textDecoration: "none",
                borderBottom: "1px solid #1A1A1A",
              }}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </nav>
  );
}
